const Chevron = ({height , width , className} : {height?:number; width?:number; className?:string;} ) => {
  return (
<svg className={className} width={width || 15} height={height || 16} viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M5.625 13L10.625 8L5.625 3L4.375 4.25L8.125 8L4.375 11.75L5.625 13Z" fill="currentColor"/>
</svg>
  )
}

export default Chevron